/*
 * Copyright (c) Nexign, JSC, 2019-2022.
 */
/**
 *
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @author Evgenij Tyan
 * @author Anton Panasenko
 * @author Ilya Babanov
 * @author Evgeniy Naumov
 * @version 1.22.0
 * @since 1.0.0
 */
import { createGlobalStyle } from 'styled-components';

import { ScrollbarStyled } from '@components/common';
import { colors, fonts, globalThemeConstants } from '@theme/index';
import '@theme/default/fonts.css';

const GlobalStyle = createGlobalStyle`
    html,
    body {
        min-height: 100%;
        padding: 0;
        margin: 0;
    }

    body {
        display: flex;

        min-width: ${globalThemeConstants.minSiteWidth}; // TODO waiting for design for the adaptive view
        overflow-y: scroll;
        background-color: ${colors.backgroundColorWhite};
        ${fonts.textMain};

        &.show-modal, &.show-onboarding {
            overflow: hidden !important;
            padding-right: 8px;

            .fixed-with-scrollbar {
                padding-right: 8px;
            }
        }
    }

    a {
        text-decoration: none;
    }

    p {
        margin-top: 0;
        margin-bottom: 1em;
    }

    h3 {
        ${fonts.textHeader3};
    }

    h5 {
        ${fonts.textHeader5};
    }

    #root {
        flex: 1 0 auto;

        display: flex;
        flex-direction: column;

        > .loader {
            flex: 1 0 auto;
            display: flex;
            flex-direction: column;

            > .loader-backdrop {
                position: fixed;
            }
        }
    }

    * {
        box-sizing: border-box;
    }

    ${ScrollbarStyled};
    ::-webkit-scrollbar {
        width: 8px;
    }
`;

export default GlobalStyle;
